<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Create New Sample'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '900px' }"
        (onHide)="close()"
>
    <div class="grid grid-cols-2 gap-6 my-3">
        <div class="flex flex-col gap-6">
            <p-ifta-label>
                <p-iconfield>
                    <p-inputicon class="pi pi-tag"></p-inputicon>
                    <input
                            pInputText
                            id="sspName"
                            [(ngModel)]="sample.sspName"
                            autocomplete="off"
                            class="w-full"
                    />
                </p-iconfield>
                <label for="sspName">SSP Name</label>
            </p-ifta-label>

            <p-ifta-label>
                <p-iconfield>
                    <p-inputicon class="pi pi-box"></p-inputicon>
                    <input
                            pInputText
                            id="es2Key"
                            [(ngModel)]="sample.es2Key"
                            autocomplete="off"
                            class="w-full"
                    />
                </p-iconfield>
                <label for="es2Key">ES2 Key <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <p-ifta-label>
                <p-select
                        [options]="fieldOfUseOptions"
                        [(ngModel)]="sample.fieldOfUse"
                        optionLabel="label"
                        optionValue="value"
                        id="field-of-use"
                        class="w-full"
                        appendTo="body"
                ></p-select>
                <label for="field-of-use">Field of Use <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <p-ifta-label>
                <p-select
                        [options]="sampleTypeOptions"
                        [(ngModel)]="sample.typeId"
                        (ngModelChange)="onSampleTypeChange($event)"
                        optionLabel="name"
                        optionValue="id"
                        id="sample-type"
                        class="w-full"
                        appendTo="body"
                ></p-select>
                <label for="sample-type">Sample Type <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <p-ifta-label>
                <p-select
                        [options]="categoryOptions"
                        [(ngModel)]="sample.categoryId"
                        (ngModelChange)="onSampleCategoryChange($event)"
                        optionLabel="name"
                        optionValue="id"
                        id="sample-category"
                        class="w-full"
                        appendTo="body"
                        [disabled]="categoryDisabled"
                ></p-select>
                <label for="sample-category">Sample Category <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <p-iftalabel class="w-full">
                <p-multi-select
                        [(ngModel)]="selectedDetails"
                        inputId="details"
                        [options]="details"
                        optionLabel="name"
                        [filter]="true"
                        styleClass="w-full"
                        [disabled]="detailsDisabled"
                ></p-multi-select>
                <label for="details">Details</label>
            </p-iftalabel>

            <p-ifta-label>
                <p-inputnumber
                        id="sample-weight"
                        mode="decimal"
                        suffix="g"
                        [(ngModel)]="sample.weight"
                        class="w-full"
                ></p-inputnumber>
                <label for="sample-weight">Weight <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <p-ifta-label>
                <p-select
                        [options]="manufacturers"
                        [loading]="loadingManufacturers"
                        [(ngModel)]="sample.manufacturerId"
                        optionLabel="name"
                        optionValue="id"
                        id="manufacturer"
                        class="w-full"
                        appendTo="body"
                        filter
                ></p-select>
                <label for="manufacturer">Manufacturer</label>
            </p-ifta-label>

            <p-ifta-label>
                <p-iconfield>
                    <p-inputicon class="pi pi-tag"></p-inputicon>
                    <input
                            pInputText
                            id="printedName"
                            [(ngModel)]="sample.printedName"
                            autocomplete="off"
                            maxlength="45"
                            class="w-full"
                    />
                </p-iconfield>
                <label for="printedName">Printed Name <span class="text-red-500">*</span></label>
                <p class="text-gray-400 text-xs">Max. 45 characters</p>
            </p-ifta-label>

        </div>

        <div class="flex flex-col gap-6">
            <div class="flex flex-col gap-1">
                <p>Languages</p>
                <div class="flex flex-col gap-2">
                    @for (language of sample.sampleLanguages; track language; let i = $index) {
                        <div>
                            <div class="flex justify-between items-start gap-2 h-full">
                                <p-select
                                        [(ngModel)]="language.languageId"
                                        [options]="getAvailableLanguages(i)"
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder="Select Language"
                                ></p-select>
                                <div class="flex flex-col flex-grow">
                                    <input
                                            [(ngModel)]="language.salesTerm"
                                            class="flex-grow"
                                            maxlength="45"
                                            pInputText
                                            placeholder="Sales Term"
                                    />
                                    <p class="text-gray-400 text-xs">Max. 45 characters</p>
                                </div>
                                <p-button
                                        (click)="removeLanguage(i)"
                                        icon="pi pi-trash"
                                        severity="danger"
                                        text
                                ></p-button>
                            </div>
                        </div>
                    }
                </div>
                <p-button
                        label="Add Language"
                        icon="pi pi-plus"
                        class="p-button-text"
                        (click)="addLanguage()"
                ></p-button>
            </div>

            <p-ifta-label>
                <p-select
                        [options]="sampleBrandingOptions"
                        [(ngModel)]="sample.defaultSampleBranding"
                        optionLabel="label"
                        optionValue="value"
                        id="sample-branding"
                        class="w-full"
                        appendTo="body"
                ></p-select>
                <label for="sample-branding">Default Sample Branding</label>
            </p-ifta-label>

            <p-ifta-label>
                <p-select
                        [options]="sampleFormatOptions"
                        [(ngModel)]="sample.format"
                        optionLabel="label"
                        optionValue="value"
                        id="sample-format"
                        class="w-full"
                        appendTo="body"
                ></p-select>
                <label for="sample-format">Sample Format <span class="text-red-500">*</span></label>
            </p-ifta-label>

            <app-select-or-upload-media [(selectedMedia)]="media"></app-select-or-upload-media>

            <p class="text-gray-400 text-xs">
                The state will automatically be set on created. With
                <span class="text-red-500">*</span> marked fields are mandatory.
            </p>
        </div>
    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveSample()"
                [loading]="loading"
                [disabled]="saveDisabled"
        ></p-button>
    </div>
</p-dialog>
